<div class="base-wireframe">
  <div class="base-wireframe__layout">
    <div class="base-wireframe__topbar">
      <ng-content select="[wireframe-block='topbar']"></ng-content>
    </div>
    <div class="base-wireframe__content">
      <div class="base-wireframe__sidebar">
        <ng-content select="[wireframe-block='sidebar']"></ng-content>
      </div>
      <div class="base-wireframe__main">
        <ng-content select="[wireframe-block='main']"></ng-content>
      </div>
    </div>
  </div>
</div>
